import Backbone from 'backbone';
import $ from 'jquery';

import i18n from '../i18n';
import Config from '../config';
import View from './view';
import queryServiceObjects from '../collection/service.objects';

import { suggest } from '../ui/helpers/suggest';
import { hashify } from '../utils/arrays';
import { postpone, delay } from '../utils/promisify';
import {
    PinBlue,
    AssigneeIcon,
    AssigneeHoverIcon,
    AssigneeInactiveIcon,
    AssigneeInactiveHoverIcon
} from './map.icons';





let ifn; i18n.then( i => ifn = i );

export default View.extend( {

    className: 'map-container',

    initialize(options = {}) {
        View.prototype.initialize.call( this, options );

        this.boundsHash_ = {};
        this.closeListener_ = null;
        this.markers_ = {};

        Backbone.$( window ).on( 'resize', 
            () => this.boundsHash_ = {} );

        this.ready_ = new Promise( resolve => this.fireReady_ = resolve );

        this.suggestionInterface_ = suggest( this.$el, '[name="search-on-map"]', ($htmlInput, page) => {
            if (!this.searchMode_)
                this.oldCenter_ = this.map_.center(),
                this.oldZoom_ = this.map_.zoom();
            this.searchMode_ = true;

            const q = $htmlInput.val().trim();
            const r = queryServiceObjects
                // minx,miny,maxx,maxy
                .execute( { query: q, bbox: Config.mapExtent() } )
                .then( items => items.map( ({ objectId, title, layerId, coords }) => ({ 
                    objectId, layerId, coords,
                    title: !layerId ? title : `<span class="glyphicon glyphicon-star"></span> ${title}`
                }) ) )
                .then( items => items.slice( 0, 10 ) )
                .then( items => ({
                    // interface is ({title, coords, fields})
                    options: items,
                    total: items.length, limit: 20,
                    offset: 0, page: 0,
                }) );

            r.catch( ex => console.error( ex ) );

            return r;
        }, ($htmlInput, itemTitle, itemData) => {
            // choose
            this.searchMode_ = false;
            // will choose point on the map and stay here
            if (itemData.layerId)
                this.trigger( 'service-object:choose', itemData );
            else
                this.trigger( 'address:choose', itemData );
            // so, make blur and stay here because searchmode = false
            $htmlInput.blur();
        }, $htmlInput => {
            // blur
            if (this.searchMode_) {
                this.searchMode_ = false;
                const {lat, lng} = this.oldCenter_;
                this.map_.setView( new M.LatLng( lat, lng ), this.oldZoom_ );
            }
            $htmlInput.val( '' );
            this.$( '.map-search' ).removeClass( '__searching' );
        }, (current/*, items*/) => {
            if (!current || !current.coords)
                return;
            const { lat, lon } = current.coords;
            this.map_.setView( new M.LatLng( +lat, +lon ), 17 );
        }, {
            showInfo: false,
        } );
    },

    events: {
        'mousedown .map-search-btn': function(e) {
            this.$( '.map-search' ).addClass( '__searching' );
            e.preventDefault();
        },

        'keydown [name="search-on-map"]': function() {
            this.$( '.map-search' ).addClass( '__searching' );
        },

        'mouseenter .map-search': function() {
            const $input = this.$( '[name="search-on-map"]' );
            if (!$input.is( ':focus' ))
                $input.focus();
        },

        'mouseleave .map-search': function() {
            const $input = this.$( '[name="search-on-map"]' );
            if (!$input.val() && !this.$( '.map-search' ).is( '.__searching' ))
                $input.blur();
        },

        'click .__zoom-in': function() {
            if (this.map_.zoom() < 20)
                this.map_.zoomIn();
        },

        'click .__zoom-out': function() {
            if (this.map_.zoom() > 1)
                this.map_.zoomOut();
        }
    },

    serialize() {
        const { locationService, search } = this.options;
        const defaults = Config.map(),
            extent = Config.mapExtent() && [...Config.mapExtent()],
            { lon, lat } = this.model && this.model.get( 'location' ) || defaults;

        let mapContext = {
            center: {
                lat: lat || defaults.lat,
                lon: lon || defaults.lon,
                zoom: defaults.zoom,
            },
            extent,
            search,
        };

        if (extent) {
            const [minLon, minLat, maxLon, maxLat] = extent;
            if (minLon && minLat && maxLon && maxLat) {
                const lon = (minLon + maxLon) / 2;
                const lat = (minLat + maxLat) / 2;
                mapContext.center = {
                    ...mapContext.center,
                    lat,
                    lon,
                };
            }
        }

        if (!this.model)
            return mapContext;

        const userId = this.model.get( 'assigned_user_id' );
        if (!userId)
            return mapContext;

        const location = locationService.getLoc( userId );
        if (location)
            mapContext.assigneeLocation = { location, user: { id: userId } };

        return mapContext;
    },

    bounds() {
        return this.map_.bounds();
    },

    center() {
        return this.map_.center();
    },

    zoom() {
        return this.map_.zoom();
    },

    setView(lon, lat, zoom) {
        this.map_.setView( new M.LatLng( lon, lat ), zoom );
    },

    fitBounds(minLat, minLon, maxLat, maxLon) {
        this.map_.fitBounds(
            new M.LatLngBounds( new M.LatLng( maxLat, maxLon ), new M.LatLng( minLat, minLon ) ) );
    },

    onMoveOrZoom(callback) {
        this.map_.on( 'zoomend', callback );
        this.map_.on( 'move', callback );
    },

    performRender(bodyString, context, firstTime) {
        if (!firstTime) return;

        this.$el.html( bodyString );

        [this.mapEl] = this.$mapEl = this.$( '.map-el' );
        if (!this.mapEl.id)
            this.mapEl.id = String( Math.random() );

        const { Class, firstAttr, options } = Config.mapClass();
        const baseLayer = new Class( firstAttr, options );

        let mapOptions = {
            center: new M.LatLng( context.center.lat, context.center.lon ),
            zoom: context.center.zoom,
            layers: [baseLayer],
            scrollWheelZoom: true
        };

        this.mapEl.extent = context.extent;
        this.mapEl.center = mapOptions.center;
        this.mapEl.MAP = this.map_ = new M.Map( this.mapEl, mapOptions );

        if ($.contains( document.body, this.mapEl )) {
            this.fireReady_();
        } else {
            const interval = setInterval( () => {
                if (!$.contains( document.body, this.mapEl ))
                    return;

                this.adjustDimensions();
                clearInterval( interval );

                this.fireReady_();
            }, 50 );
        }

        this.map_.on( 'click', ({ latlng: { lat, lng } }) => 
            this.trigger( 'map:click', { lat, lon: lng } ) );
    },

    adjustDimensions() {
        let e;
        if (typeof Event === 'function') {
            e = new Event( 'resize' );
        } else {
            e = document.createEvent('Event');
            e.initEvent( 'resize', true, true );
        }

        window.dispatchEvent( e );
    },

    afterRender(context, firstTime) {
        this.suggestionInterface_.unbindEvents();
        this.suggestionInterface_.bindEvents();

        if (!this.model || !this.model.get( 'location' ))
            return updateLayer( this, 'bydistance', [] ),
                updateLayer( this, 'location', [] ),
                updateLayer( this, 'assignee', [] ),
                this.spanToExtent_( context.extent, firstTime );

        if (this.locationsChannel_)
            this.locationsChannel_.close();
        this.markers_ = {};

        const mapUsers = context.mapUsers || [];

        const containsAssignee = context.assigneeLocation
            && mapUsers.some( ({ location: { user_id } }) => 
                user_id = context.assigneeLocation.location.user_id );

        // show potential assignees at given radius
        updateLayer( this, 'bydistance', 
            newLayer( this.map_, mapUsers, 
                userLocation => getLayerIcon( userLocation ),
                (layer, layerInfo) => {
                    newAssigneePopup( this, layer, layerInfo, context.capabilities );
                    this.markers_[layerInfo.user.id] = layer;
                } ) ); // { id, title, fio, organization_id }

        // show both point and assignee
        updateLayer( this, 'location', 
            newClusterLayer( this.map_, { location: this.model.get( 'location' ) }, PinBlue ) );
        updateLayer( this, 'assignee', 
            newLayer( this.map_, !containsAssignee ? context.assigneeLocation : [], 
                userLocation => getLayerIcon( userLocation ),
                (layer, layerInfo) => this.markers_[layerInfo.user.id] = layer ) );

        const locations = mapUsers.slice() || [];

        if (!containsAssignee)
            if (context.assigneeLocation)
                locations.push( context.assigneeLocation );

        const ids = hashify( locations.map( ({ user: { id } }) => id ) );
        this.locationsChannel_ = this.options.locationService
            .map( locations => locations.filter( ({ user: { id } }) => !!ids[id] ) );

        this.locationsChannel_.forEach( locations => 
            locations.forEach( ({ user: { id }, location }) => {
                const { lon, lat } = location;
                this.markers_[id].setLatLng( new M.LatLng( lat, lon ) );
                this.markers_[id].setIcon( getLayerIcon( { location } ) );
            } ) );

        if (this.model.get( 'location' ))
            locations.push( { location: this.model.get( 'location' ) } );

        if (!locations.length && context.extent)
            return this.spanToExtent_( context.extent, firstTime );

        return this.spanTo_( locations, firstTime );
    },

    spanToExtent_(extent, firstTime) {
        if (!extent)
            return;

        const [minLon, minLat, maxLon, maxLat] = extent;
        
        const lb = { location: { lat: minLat, lon: minLon } },
            rt = { location: { lat: maxLat, lon: maxLon } },
            extentCorners = [lb, rt];

        return this.spanTo_( extentCorners, firstTime );
    },

    spanTo_(locations, firstTime) {
        return this.ready_
            .then( () => firstTime ? delay( 300 ) : postpone() )
            .then( () => spanBounds( this, locations ) );
    },

    updateLayer(...args) {
        updateLayer( this, ...args );
    },

    newMarkerLayer(...args) {
        return newLayer( this.map_, ...args );
    },

    newClusterLayer(...args) {
        return newClusterLayer( this.map_, ...args );
    },

} );

function getLayerIcon({ current, location: { active } }) {
    if (current)
        return active ? AssigneeHoverIcon() : AssigneeInactiveHoverIcon();

    return active ? AssigneeIcon() : AssigneeInactiveIcon();
}

function updateLayer(view, layerName, layerValue) {
    view[layerName] = view[layerName] || [];
    view[layerName].forEach( layer => view.map_.removeLayer( layer ) );

    if (!layerValue)
        return;

    if (!(layerValue instanceof Array))
        layerValue = [layerValue];

    view[layerName] = [...layerValue];
    view[layerName].forEach( layer => view.map_.addLayer( layer ) );
}

function newLayer(map, markersAttrs, Icon, cb = () => {}) {
    if (!markersAttrs)
        return;

    if (!(markersAttrs instanceof Array))
        markersAttrs = [markersAttrs];

    return markersAttrs
        .filter( ({ location }) => !!location )
        .map( markerAttrs => {
            const { location: { lon, lat } } = markerAttrs,
                latlng = new M.LatLng( lat, lon ),
                icon = 'function' === typeof Icon ? Icon( markerAttrs ) : Icon;

            const marker = new M.Marker( latlng, 
                { icon: 'function' == typeof icon ? new icon() : icon } );
            return cb( marker, markerAttrs ) || marker;
        } );
}

function newClusterLayer(map, markerAttrs, Icon, cb = () => {}) {
    return newLayer(
        map,
        markerAttrs, Icon,
        (marker, markerAttrs) => {
            const iconClass = 'function' === typeof Icon ? Icon( markerAttrs ) : Icon;

            const cluster = new M.Cluster.Marker( marker, map, {
                iconClass,
                radius: 1.5,
                singleClusters: true
            } );

            cluster.options.icon.update( markerAttrs.title || '' , cluster._icon );

            return cb( cluster, markerAttrs ) || cluster;
        }
    );
}

function spanBounds(view, layersInfo) {
    if (!layersInfo.length)
        return;

    if (layersInfo.length === 1) {
        const [{ location: { lon, lat } }] = layersInfo;
        if (!eqCenter( view, { lng: lon, lat } ))
            return view.map_.setView( new M.LatLng( +lat, +lon ), view.map_.zoom() ),
                delay( 300 );

        return;
    }

    let minLon = 1e9, maxLon = -1, minLat = 1e9, maxLat = -1;

    layersInfo.forEach( ({ location: { lon, lat } }) => {
        minLon = Math.min( minLon, +lon );
        maxLon = Math.max( maxLon, +lon );
        minLat = Math.min( minLat, +lat );
        maxLat = Math.max( maxLat, +lat );
    } );

    const midLon = .5 * (minLon + maxLon),
        midLat = .5 * (minLat + maxLat);

    minLon = midLon + 1.25 * (minLon - midLon); 
    maxLon = midLon + 1.25 * (maxLon - midLon); 
    minLat = midLat + 1.25 * (minLat - midLat); 
    maxLat = midLat + 1.25 * (maxLat - midLat); 
    const b = new M.LatLngBounds( new M.LatLng( maxLat, maxLon ), new M.LatLng( minLat, minLon ) );

    if (!eqBounds( view, b ))
        return view.map_.fitBounds( b ),
            delay( 300 ).then( () => view.boundsHash_[JSON.stringify( b )] = view.map_.bounds() );
}

function newAssigneePopup(view, layer, layerInfo, caps) {
    layer.on( 'click', () => view.trigger( 'assignee:click' ) );

    if (caps && caps.assign_user) {
        const guid = `x${Math.random().toFixed( 10 ).substr( 2 )}`;
        window[guid] = () => view.trigger( 'assignee:assign', layerInfo ); // title, user, location
        layer.bindPopup( `${layerInfo.title} <a href="javascript:void(0);" onclick="${guid}();">${ifn( 'actions::choose' )}</a>`, {} );
    } else
        layer.bindPopup( `${layerInfo.title}`, {} );
}

function eqBounds(view, bounds) {
    const code = JSON.stringify( bounds );
    if (!view.boundsHash_[code])
        return false;

    bounds = view.boundsHash_[code];
    const b = view.map_.bounds();
    return eqLocation( b._northEast, bounds._northEast )
        && eqLocation( b._southWest, bounds._southWest );
}

function eqCenter(view, location) {
    return eqLocation( view.map_.center(), location );
}

function eqLocation(x, y) {
    const { lng: lo0, lat: la0 } = x,
        { lng: lo1, lat: la1 } = y;

    return eq( lo0, lo1 ) 
        && eq( la0, la1 );
}

function eq(x, y) {
    return Math.abs( x - y ) < 1e-3;
}


// WEBPACK FOOTER //
// ./src/js/view/map.js